import { useCallback, useEffect, useState } from 'react';
export const useNotification = (isMinimized, isSnappedToLatest) => {
    const [notifications, setNotifications] = useState(0);
    useEffect(() => {
        if (!isMinimized && isSnappedToLatest)
            setNotifications(0);
    }, [isSnappedToLatest, isMinimized]);
    const addNotifications = useCallback((n) => {
        if (n <= 0)
            return;
        if (isMinimized || !isSnappedToLatest) {
            setNotifications(num => num + n);
        }
    }, [isMinimized, isSnappedToLatest]);
    return [notifications, addNotifications];
};
//# sourceMappingURL=useNotification.js.map